//-----function for loader------
function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-blackTrasparent z-50">
      <div className="border-8 w-[50px] h-[50px] border-dashed border-primary rounded-full animate-spin"></div>
    </div>
  );
}
export default Loader;
